export default __webpack_public_path__ + "static/media/aguacatala.2a699e26.png";